import React from 'react';
export function Footer() {
  return <footer className="bg-brand-950 px-4 pb-32 pt-10 text-center" data-id="element-143" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl" data-id="element-144" data-mp="3gfiyquovsxjx">
        <p className="font-serif text-lg font-bold text-white" data-id="element-145" data-mp="3ghc2o28413o8">Apometry Practice Deck™</p>
        <p className="mt-1 text-sm text-brand-200" data-id="element-146" data-mp="32pp57z2flp3v">Created by Helena Duarte</p>
        <p className="mt-6 text-xs leading-relaxed text-brand-200/80" data-id="element-147" data-mp="36q94p9ah94t6">
          The practices and concepts presented are within the scope of spirituality, personal reflection and symbolic
          practices. They do not constitute medical or psychological diagnosis or treatment and do not replace care from
          qualified professionals.
        </p>
        <p className="mt-4 text-xs text-brand-200/70" data-id="element-148" data-mp="3qd6pzana3mxc">© 2026 · Apometry Practice Deck™ · All Rights Reserved.</p>
      </div>
    </footer>;
}